import React, { useEffect, useMemo, useState } from 'react';
import { computeCountdown, formatCountdownLabel } from './combatTimers';

export const COUNTDOWN_REFRESH_MS = 120;

function CountdownBarComponent({ label, remaining, interval, progress, filled, variant = 'player' }) {
  const clampedProgress = Math.max(0, Math.min(progress ?? 0, 1));
  const remainingLabel = formatCountdownLabel(remaining);
  const ariaNow = Math.max(0, Math.min(interval ?? 0, filled ?? 0));

  return (
    <div className={`countdown-bar countdown-bar--${variant}`}>
      <div className="countdown-bar__header">
        <span>{label}</span>
        <span>{remainingLabel}</span>
      </div>
      <div
        className="countdown-bar__track"
        role="progressbar"
        aria-valuemin={0}
        aria-valuemax={interval ?? 0}
        aria-valuenow={ariaNow}
        aria-label={`${label} ${remaining > 0 ? `in ${remainingLabel}` : 'ready'}`}
      >
        <div style={{ width: `${clampedProgress * 100}%` }} />
      </div>
    </div>
  );
}

const CountdownBar = React.memo(CountdownBarComponent);

export function LiveCountdownBar({ timer, ...props }) {
  const [tick, setTick] = useState(() => Date.now());

  useEffect(() => {
    if (!timer) return undefined;
    setTick(Date.now());
    const intervalId = window.setInterval(() => {
      setTick(Date.now());
    }, COUNTDOWN_REFRESH_MS);
    return () => window.clearInterval(intervalId);
  }, [timer]);

  const countdown = useMemo(
    () => computeCountdown(timer, tick),
    [tick, timer],
  );
  if (!countdown) return null;

  return <CountdownBar {...props} {...countdown} />;
}

export default CountdownBar;
